import { cn } from "../lib/utils";

export const Panel = ({ title, subtitle, action, children, className, testId }) => (
  <div
    className={cn(
      "bg-white border border-slate-200 rounded-md p-5 flex flex-col",
      className
    )}
    data-testid={testId}
  >
    {(title || action) && (
      <div className="flex items-start justify-between mb-4 gap-3">
        <div>
          {title && (
            <h3 className="text-sm font-semibold text-slate-900 tracking-tight">
              {title}
            </h3>
          )}
          {subtitle && (
            <p className="text-xs text-slate-500 mt-0.5">{subtitle}</p>
          )}
        </div>
        {action}
      </div>
    )}
    <div className="min-h-0">{children}</div>
  </div>
);
